export default {
  get: {

  },
  post: {
    add: '/member/add', // 添加人员
    sendCode: '/member/send-code', // 发送手机验证码
    getPersonnelList: '/member/get-list-to-store', //门店人员相关 / 门店关联的人员列表
    changeStatus: '/member/change-status', // 变更人员状态
    getPersonList: '/member/list',// 获取人员列表
    saveRelStore: '/member/save-rel-store',// 门店人员相关 / 编辑人员保存
    getPersonDetail: '/member/detail',// 获取人员详情
    addStore: '/member/add-store',// 门店人员相关 / 门店关联人员
    close: '/member/close',
    open: '/member/open',
    exportPersonnelList: '/member/export-list',
    save: '/member/save',
    changeDelete: '/member/delete',
  }
}